import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType, PatchQueryArgsType } from "../../../types";
import {
  GetExpenseUnitDetailsResponseType,
  GetExpenseUnitsParams,
  GetExpenseUnitsResponseType,
} from "../../../types/org-setting/expenseUnit";

export const expenseUnitApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseUnits: builder.query<
      GetExpenseUnitsResponseType,
      GetQueryArgsType<GetExpenseUnitsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getExpenseUnits,
        ...queryArgs,
      }),
      providesTags: ["GetExpenseUnits"],
    }),
    getExpenseUnitDetails: builder.query<
      GetExpenseUnitDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getExpenseUnitDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetExpenseUnitDetails",
          id,
        },
      ],
    }),
    addExpenseUnit: builder.mutation({
      query: (data) => ({
        url: API_URL.addExpenseUnit,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetExpenseUnits"];
        return [];
      },
    }),
    updateExpenseUnit: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateExpenseUnit}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetExpenseUnits",
            {
              type: "GetExpenseUnitDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateExpenseUnitStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateExpenseUnitStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetExpenseUnits",
            {
              type: "GetExpenseUnitDetails",
              id,
            },
          ];

        return [];
      },
    }),
    deleteExpenseUnit: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_URL.deleteExpenseUnit}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetExpenseUnits"];
        return [];
      },
    }),
  }),
});

export const {
  useGetExpenseUnitsQuery,
  useGetExpenseUnitDetailsQuery,
  useAddExpenseUnitMutation,
  useUpdateExpenseUnitMutation,
  useUpdateExpenseUnitStatusMutation,
  useDeleteExpenseUnitMutation,
} = expenseUnitApi;
